import { render, staticRenderFns } from "./tinkHome.vue?vue&type=template&id=1d50a5b6&scoped=true"
import script from "./tinkHome.vue?vue&type=script&lang=js"
export * from "./tinkHome.vue?vue&type=script&lang=js"
import style0 from "./tinkHome.vue?vue&type=style&index=0&id=1d50a5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d50a5b6",
  null
  
)

export default component.exports